import { AfterViewInit, Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LoaderService } from './shared/services/loader/loader.service';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  public title = 'Simulador';
  /**
   * Código de la cámara para la cual se compiló
   */
  public codeCamara = CONFIG.CodigoCamara;
  /**
   * Estado de carga de un módulo
   */
  public isLoadingModule: boolean;
  /**
   * Estado de actividad de la capa de carga
   */
  public isActiveLoader: boolean;
  constructor(@Inject(DOCUMENT) private doc: Document,
              private loaderService: LoaderService,
              private router: Router) {
    this.isLoadingModule = true;
    let link: HTMLLinkElement = this.doc.createElement('link');
    let icon: string = '';

    if(this.codeCamara === '21') icon = './assets/icons/favicon.ico';
    if(this.codeCamara === '9') icon = './assets/icons/favicon_cccar.ico';
    if(this.codeCamara === '29') icon = './assets/icons/favicon_ccq.ico';

    link.setAttribute('rel', 'icon');
    link.setAttribute('type', 'image/x-icon');
    link.setAttribute('href', icon);
    this.doc.head.appendChild(link);

    this.loaderService.loaderActive$.subscribe((isActive) => {
      setTimeout(() => {
        this.isActiveLoader = isActive;
      }, 0);
    });
  }

  /**
   * Ejecuta la comprovación del paso de una ruta a otra luego de que el componente ha cargado completamente
   * @method ngAfterViewInit
   * @returns {void}
   */
  ngAfterViewInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        window.scrollTo(0, 0);
        this.isLoadingModule = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.isLoadingModule = false;
      }
    });
  }
}
